import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();

  return (
    <div className="footer-container">
      <div className="footer-links">
        <div className="footer-link-wrapper">
          <div className="footer-link-items">
            <h2>{t("footer.oneNizer")}</h2>
            <Link to="/app">{t("footer.app")}</Link>
            <Link to="/aboutus">{t("footer.aboutUs")}</Link>
            <Link to="/contact">{t("footer.contact")}</Link>
          </div>

          <div className="footer-link-items">
            <h2>{t("footer.company")}</h2>
            <Link to="/careers">{t("footer.career")}</Link>
            <Link to="/imprint">{t("footer.imprint")}</Link>
            <Link to="/privacypolicy">{t("footer.privacyPolicy")}</Link>
            <Link to="/termsofuse">{t("footer.termsOfUse")}</Link>
          </div>
        </div>

        <div className="footer-link-wrapper">
          <div className="footer-link-items">
            <h2>{t("footer.support")}</h2>
            <Link to="/contact">{t("footer.helpCenter")}</Link>
            <Link to="/contact">Support</Link>
            <Link to="/contact">{t("footer.contact")}</Link>
          </div>
        </div>
      </div>

      <section className="social-media">
        <div className="social-media-wrap">
          <div className="footer-logo">
            <Link to="/" className="navbar-logo">
              <img
                src="/images/logo/navbar-logo.png"
                alt="Onenizer Logo"
                className="navbar-logo-img"
              />
            </Link>
          </div>
          <small className="website-rights">ONENIZER © 2026</small>
          <div className="social-icons">
            <a
              className="social-icon-link"
              href="https://instagram.com/onenizer"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram" />
            </a>
            <a
              className="social-icon-link"
              href="https://twitter.com/onenizer"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <i className="fab fa-twitter" />
            </a>
            <a
              className="social-icon-link"
              href="https://linkedin.com/company/onenizer"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <i className="fab fa-linkedin" />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
